module.exports = __webpack_public_path__ + "static/img/img_awards_2en.b80480a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/img_awards_2en.png
// module id = HoXC
// module chunks = 15